import React from 'react';
import { closeIcon } from '@chordbaker/design';

interface CloseIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

const CloseIcon: React.FC<CloseIconProps> = ({ size = closeIcon.defaultSize, color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={closeIcon.fill}
    viewBox={closeIcon.viewBox}
    strokeWidth={closeIcon.strokeWidth}
    stroke={color}
    width={size}
    height={size}
    strokeLinecap={closeIcon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
    strokeLinejoin={closeIcon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
    {...props}
  >
    <path d={(closeIcon.elements[0] as { d: string }).d} />
  </svg>
);

export default CloseIcon;
